module.exports = __webpack_public_path__ + "static/media/nest1.a42d811b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/flexhouse/nest1.mp4
// module id = 94
// module chunks = 0